export const newCourseBread = [
  {
    href: '/',
    name: 'Dashboard',
    key: '1',
  },
  {
    href: '/courseplan',
    name: 'Kursy',
    key: '2',
  },
];

export const statisticsBread = [
  {
    href: '/',
    name: 'Dashboard',
    key: '1',
  },
  {
    href: '/courseplan',
    name: 'Kursy',
    key: '2',
  },
  {
    href: '/courseplan/cours',
    name: 'UX Design od podstaw',
    key: '3',
  },
];
